import * as React from "react";
import theme from "@theme";
import { Avatar } from "@mui/material";
import Tooltip from "@mui/joy/Tooltip";

const CustomAvatar = (props) => {
  const {
    src,
    value,
    alt,
    backgroundColor = theme.colors.orange,
    height = 20,
    width = 20,
    fontSize = "2px",
    margin = "0 auto",
    alignItems = "center",
    color = theme.colors.white,
    zIndex = 2001,
    boxBackgroundColor,
    sx,
    onClick = () => {},
    placement = "top-end",
  } = props;

  const truncatedValue = value
    ? value.length > 5
      ? value.substring(0, 5) + "..."
      : value
    : "";

  const handleTooltipClick = (event) => {
    event.stopPropagation();
  };

  return (
    <div
      style={{
        textAlign: "center",
        margin: "2px",
        backgroundColor: boxBackgroundColor ? boxBackgroundColor : "#FEF4E9",
        padding: "3.5px",
        borderRadius: "5px",
        ...sx,
      }}
    >
      <Tooltip
        placement={placement}
        variant="outlined"
        arrow
        sx={{
          zIndex: zIndex,
        }}
        title={value ? value : ""}
        onClick={handleTooltipClick}
      >
        <Avatar
          sx={{
            backgroundColor: backgroundColor,
            height: height,
            width: width,
            margin: margin,
            marginBottom: "1px",
            display: "flex",
            justifyContent: "center",
            alignItems: alignItems,
            fontSize: fontSize,
            color: color,
            "& img": {
              height: "40%",
              width: "55%",
              objectFit: "cover",
            },
          }}
          onClick={onClick}
          alt={alt}
          src={src}
        />
      </Tooltip>
      <span style={{ color: theme.colors.orange, fontSize: "11px" }}>
        {truncatedValue}
      </span>
    </div>
  );
};

export default CustomAvatar;
